var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.inPreview,
      expression: "!inPreview"
    }],
    staticClass: "component-extension"
  }, [_c('div', {
    staticClass: "btn-list"
  }, [_c('div', {
    staticClass: "extension-btn",
    on: {
      "click": _vm.showExtensionDialog
    }
  }, [_c('i'), _c('span', [_vm._v("推广")])]), _c('div', {
    staticClass: "bar"
  }), _c('div', {
    staticClass: "preview-btn",
    on: {
      "click": _vm.goPreview
    }
  }, [_vm._v("\n      预览\n    ")])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.extensionDialog.show,
      expression: "extensionDialog.show"
    }],
    staticClass: "extension-dialog"
  }, [_c('div', {
    staticClass: "overlay",
    class: {
      show: _vm.extensionDialog.showContent
    },
    on: {
      "click": _vm.closeExtensionDialog
    }
  }), _c('div', {
    staticClass: "dialog-body",
    class: {
      show: _vm.extensionDialog.showContent
    }
  }, [_c('div', {
    staticClass: "dialog-content"
  }, [_c('div', {
    staticClass: "share-btn",
    on: {
      "click": _vm.getPoster
    }
  }, [_c('div', {
    staticClass: "share-bg poster-type"
  }), _c('span', {
    staticClass: "btn-name"
  }, [_vm._v("店铺海报")])]), _c('div', {
    staticClass: "share-btn",
    on: {
      "click": _vm.copyLink
    }
  }, [_c('div', {
    staticClass: "share-bg link-type"
  }), _c('span', {
    staticClass: "btn-name"
  }, [_vm._v("店铺链接")])])]), _c('div', {
    staticClass: "cancel-btn",
    on: {
      "click": _vm.closeExtensionDialog
    }
  }, [_vm._v("取消")])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.posterDialog.show,
      expression: "posterDialog.show"
    }],
    staticClass: "poster-dialog"
  }, [_c('div', {
    staticClass: "overlay",
    class: {
      show: _vm.posterDialog.showContent
    },
    on: {
      "click": _vm.closePosterDialog
    }
  }), _c('div', {
    staticClass: "dialog-body",
    class: {
      show: _vm.posterDialog.showContent
    }
  }, [_c('div', {
    staticClass: "dialog-content"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: _vm.getLazyImg(_vm.posterUrl, '?imageView2/1/w/560/h/632/interlace/1/q/85/'),
      expression: "getLazyImg(posterUrl,'?imageView2/1/w/560/h/632/interlace/1/q/85/')"
    }]
  })]), _c('div', {
    staticClass: "dialog-tips"
  }, [_vm._v("长按海报即可保存/分享")]), _c('div', {
    staticClass: "close-btn",
    on: {
      "click": _vm.closePosterDialog
    }
  })])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };